import { Outlet } from "react-router-dom";
import { getContextSidebar } from "../../services/base/layoutSlice";
import { useSelector } from "react-redux";
import Sidebar from "./Sidebar";
import ContextSidebar from "./ContextSidebar";

const ProtocolsLayout = () => {
  const contextSidebar = useSelector(getContextSidebar);

  return (
    <div className="flex md:flex-row flex-column p-4">
      <div className="flex flex-column md:w-2 shadow-4">
        <Sidebar />
        {contextSidebar && <ContextSidebar />}
      </div>

      <div className="flex flex-column flex-grow-1 md:w-10 mx-4">
        <Outlet />
      </div>
    </div>
  );
};

export default ProtocolsLayout;
